export default [
  {
    path: 'afiliados/afiliado-relatorio',
    name: 'afiliado-relatorio',
    component: () => import('./index'),
    children: [],
    meta: {
      visible: true,
      title: 'Relatório',
      breadcrumb: [
        { name: 'Home', link: 'home' },
        { name: 'Afiliados', link: 'afiliados' },
        { name: 'Relatório' },
      ]
    }
  },
]